module.exports = __webpack_public_path__ + "bi.21c1ff1f.svg";